var React = require('react');

function IcOrcid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 0C24.8375 0 32 7.1625 32 16C32 24.8375 24.8375 32 16 32C7.1625 32 0 24.8375 0 16C0 7.1625 7.1625 0 16 0ZM13.6123 23.2871H18.8379C23.2502 23.2869 25.9375 20.0243 25.9375 16.5869C25.9373 13.4245 23.7622 9.8877 18.8125 9.8877H13.6123V23.2871ZM8.8623 23.2744H10.7871V9.8877H8.8623V23.2744ZM18.5 11.625C22.2498 11.625 23.9627 13.8996 23.9629 16.5869C23.9629 18.2369 22.9621 21.5498 18.5996 21.5498H15.5371V11.625H18.5ZM9.8252 5.83691C9.12526 5.83691 8.56261 6.3997 8.5625 7.09961C8.5625 7.78711 9.1252 8.3623 9.8252 8.3623C10.5251 8.3622 11.0879 7.78705 11.0879 7.09961C11.0878 6.41226 10.525 5.83702 9.8252 5.83691Z","fill":"black"}));
}

IcOrcid.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = IcOrcid;

IcOrcid.default = IcOrcid;
